export const ORIFLAME_LOGO_ROOT = 'oriflame-logo';
export const FAVORITE_HEART_ROOT = 'favorite-heart-root';
export const USER_ICON_MOBILE = 'user-icon-mobile';
export const USER_ICON_DESKTOP = 'user-icon-desktop';
export const ROOT_WRAPPER = 'root-wrapper';
export const NOTIFICATION_BELL_ICON_BUTTON = 'notification-bell-icon-button';
export const NOTIFICATION_BELL_ICON_BELL = 'notification-bell-icon-bell';

export const MY_PAGES_URL = '/ssoidentity/mypages';

export const basePositionStyles = {
  bottom: 0,
  left: 0,
  position: 'fixed',
  right: 0,
  top: 0,
} as const;
